const navbar = (editor) => {

    editor.BlockManager.add(`navbar`, {
        category: 'Headers & Footers',
        label: `
          <div ><svg  width='1.4vw' height='1.6vw' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 9c0-.6-.5-1-1.3-1H3.4C2.5 8 2 8.4 2 9v6c0 .6.5 1 1.3 1h17.4c.8 0 1.3-.4 1.3-1V9zm-1 6H3V9h18v6zM5 10h2c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H5a1 1 0 01-1-1v-2c0-.6.4-1 1-1zm10 0h5v1h-5v-1zm0 3h5v1h-5v-1zm0-1.5h5v1h-5v-1z"></path></svg></div>

          <div class = ' gjs-fontFamily'>Header</div>
          `,
        attributes: {},
        content: `
            <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
              <div class="container-fluid" style="margin-bottom: 0px">
                  <span class="pointer navbar-brand" href="#!">Start Wabli</span>
                  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
                  <div class="collapse navbar-collapse" id="navbarSupportedContent">
                      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                          <li class="nav-item nav-link pointer" href="#">Home</li>
                          <li class="nav-item nav-link pointer" href="#!">About</li>
                          <li class="nav-item nav-link pointer" href="#!">Contact</li>
                          <li class="nav-item nav-link active pointer" aria-current="page" href="#">Blog</li>
                      </ul>
                  </div>
              </div>
          </nav>
          `
      });


}

export default navbar;